import { NavRoute } from '../../shared/navigation/nav.route.interface';
import { PermissionProfileEnum } from '../../../app/core/enums/generated/PermissionProfileEnum';
import { UserJsVm } from '../../shared/generated/Administration/Models/UserJsVm';

/***************************************************************************************************
 * Global Reports Nav
 * All reports should be linked from here
 */
export const getReportsNav: () => NavRoute = () => {
    var user: UserJsVm = JSON.parse(localStorage.getItem('user')!);
    return {
        name: 'Reports',
        security: (sec) =>
            sec?.permissionProfile == PermissionProfileEnum.Admin ||
            user?.isTeamLead,
        children: getChildrenNavRoutes(),
    };
};

function getChildrenNavRoutes(): NavRoute[] {
    let navRoutes: NavRoute[] = [
        {
            name: 'Site Contacts',
            security: (sec) =>
                sec?.permissionProfile == PermissionProfileEnum.Admin,
            path: 'reports/site-contacts',
        },
        {
            name: 'Daily Site',
            path: 'reports/daily-site',
        },
    ];

    return navRoutes;
}
